import React from 'react'

/**
 * The home hero's artwork: a credit card, because that is the business.
 *
 * It is deliberately a different object from the Services page's card stack —
 * that one is a small, flat, front-facing programme of sheets. This is a
 * single card in perspective with a milled chip, contactless mark, embossed
 * number groups and a specular sweep, over the portfolio curve the home copy
 * promises. Same brand, different sentence.
 *
 * Drawn in CSS and SVG: no image to licence, sharp at any density, and it can
 * only ever paint with palette tokens.
 */
const HeroArt = () => (
  <figure className="heroArt" aria-hidden="true">
    <span className="heroArt__grid" />

    {/* The portfolio behind the card */}
    <div className="heroArt__panel">
      <svg className="heroArt__chart" viewBox="0 0 300 120" preserveAspectRatio="none">
        <defs>
          <linearGradient id="heroFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="var(--navy)" stopOpacity="0.26" />
            <stop offset="100%" stopColor="var(--navy)" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path
          className="heroArt__area"
          d="M4,104 C48,98 70,84 100,74 S154,56 182,42 S246,20 296,10 L296,120 L4,120 Z"
          fill="url(#heroFill)"
        />
        <path
          className="heroArt__line"
          d="M4,104 C48,98 70,84 100,74 S154,56 182,42 S246,20 296,10"
          pathLength="1"
        />
      </svg>
      <span className="heroArt__head" />
    </div>

    {/* The card */}
    <div className="heroArt__card">
      <span className="heroArt__sheen" />

      {/* Four dots, echoing the mark in the logo */}
      <span className="heroArt__dots">
        <i />
        <i />
        <i />
        <i />
      </span>

      <span className="heroArt__chip" />
      <span className="heroArt__wave" />

      <span className="heroArt__pan">
        <i />
        <i />
        <i />
        <i />
      </span>

      <span className="heroArt__foot">
        <i />
        <i />
      </span>
    </div>
  </figure>
)

export default HeroArt
